module.exports = __webpack_public_path__ + "static/media/wisdom.9e81e623.svg";